<template>
  <header :class="{ 'dark': dark, 'active' : isOpen}">
    <router-link to="/">
      <img v-if="!dark" src="../../assets/logo.png">
      <img v-else src="../../assets/logogr.png">
    </router-link>
    <input type="checkbox" class="nav-toggle" v-model="isOpen" @change="preventScroll"/>
    <div class="hamburger">
      <span v-for="i in 3" class="hamburger-item"></span>
    </div>
    <nav>
      <template v-for="item, index in navigation">
        <router-link :to="item.link" :key="item.text">
          {{ item.text }}
        </router-link>
        <span v-if="index != navigation.length - 1">/</span>
      </template>
    </nav>
  </header>
</template>

<script>
  export default {
    props: {
      id: String,
      name: String,
      dark: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        navigation: [
          {link: '/', text: 'Home'},
          {link: '/about', text: 'About Me'},
          {link: '/portfolio', text: 'Portfolio'},
          {link: '/contact', text: 'Contact'},
        ],
        words: ['Creative', 'Unique', 'Innovative', 'Fat'],
        isOpen: false
      }
    },

    created() {
      this.open = false;
      this.preventScroll();
    },

    methods: {
      preventScroll: function () {
        document.documentElement.style.overflow = this.isOpen ? 'hidden' : 'auto';
      }
    }
  }
</script>

<style lang="scss">
  @import "../../css/main.scss";
  @import "../../css/navigation.scss";

</style>


// WEBPACK FOOTER //
// navigation.vue?7e6ec078